import React from "react";
import { Link } from "react-router-dom";

const WorkshopCard = (props) => {
  const { imgUrl, title, isOffered, students, rating } = props.item;

  return (
    <li className="workshop">
      <div className="workshop__img">
        <img
        width={100}
        height={100}
          loading="lazy"
          src={imgUrl}
          srcSet={`
    ${imgUrl} 480w,
    ${imgUrl} 800w,
    ${imgUrl} 1200w,
    ${imgUrl} 1600w
  `}
          sizes="(max-width: 600px) 480px, 
         (max-width: 1200px) 800px, 
         1200px"
          className="block w-full aspect-[1/1]"
          alt={title}
          title={title}
        />
      </div>

      <div className="workshop__details">
        <h3>{title}</h3>

        <div className="workshop__details__footer">
          <span className=" d-flex align-items-center gap-2">
            <i className="ri-user-line"></i> {isOffered ? students : "NA"}
          </span>

          <span className=" d-flex align-items-center gap-2">
            <i className="ri-star-fill"></i> {isOffered ? rating : "NA"}
          </span>
          <Link to="" className="workshop__btn">
            {isOffered ? "Free" : "Coming Soon"}
          </Link>
        </div>
      </div>
    </li>
  );
};

export default WorkshopCard;
